export function isGamesApp() {
  const isGamesApp = typeof navigator !== 'undefined' && /WTGamesApp/i.test(navigator.userAgent);

  return isGamesApp;
}
